import React from 'react';

const DistractofColumbia = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        District of Columbia Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Property Disclosure Statement: Required for residential sales.</li>
        <li>
          Lead-Based Paint: Mandatory disclosure for homes built before 1978.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2021/02/Washington-DC-Sellers-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – Required by law for sellers to complete and provide to buyers. This
          form is approved by the District of Columbia.
        </li>
      </ol>
    </div>
  );
};

export default DistractofColumbia;
